<template>
  <div class="bg-white border border-gray-700 py-2 px-4 rounded shadow-xl">
    <div class="flex justify-start">
      <div class="w-2/6 flex">
        <span class="border border-gray-500 rounded-full mr-4">
          <i :class="notificationIconClass"></i>
          <!-- Water-->
        </span>
        <a @click.prevent="toggleDisplay" href="" class="link">
          {{ meterNumber }}
        </a>
      </div>
      <div class="w-2/6"><i class="fa fa-map-marker-alt"></i> {{ address }}</div>
      <div class="w-1/6"><i class="fa fa-calendar-alt"></i> {{ displayDate }}</div>
      <div class="w-1/6 text-right">
        <i class="fa fa-chart-area"></i>
      </div>
    </div>
    <div v-if="open">
      <div class="my-4">
        {{ notification.data.message }}
      </div>
      <div class="flex justify-end space-x-12">
        <div>
          <a @click.prevent="dismiss" href="" class="text-gray-400 text-xs">
            <i class="fa fa-times-circle"></i> Dismiss this notification
          </a>
        </div>
        <div>
          <a @click.prevent="meterSelected" href="" class="text-gray-400 text-xs">
            <i class="fa fa-chart-line"></i> Show data in graph
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const iconClasses = {
  1: 'fa fa-bolt',
  5: 'fa fa-tint',
};

export default {
  name: 'ConsumptionNotificationRow.',
  props: {
    notification: {
      type: Object,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    obj() {
      return this.notification.data.obj;
    },
    notificationIconClass() {
      const iconClass = iconClasses[this.obj.consumption_category_id];
      return iconClass ? `${iconClass} icon_gray` : '';
    },
    meterNumber() {
      return this.obj.consumption_meter.meter_number;
    },
    displayDate() {
      const input = this.obj.date;
      const parts = input.split('-');
      const date = new Date(`${parts[1]}-${parts[0]}-15`);
      return date.toLocaleString('default', { month: 'short' }) + ' ' + parts[1];
    },
    address() {
      const address = this.obj.consumption_meter.address;
      if (address) {
        return address;
      }
      return `Address for meter ${this.meterNumber}`;
    },
  },
  methods: {
    toggleDisplay() {
      this.open = !this.open;
    },
    meterSelected() {
      this.$emit('selected', this.obj.consumption_meter);
    },
    dismiss() {
      this.$emit('dismiss', this.notification);
    },
  },
};
</script>

<style scoped>
.icon_gray {
  color: rgb(107 114 128);
}
</style>
